import React from 'react';

const SectionHeading = ({ subtitle, title, description, centered = true }) => {
  return (
    <div className={`mb-16 ${centered ? 'text-center' : 'text-left'}`}>
      {subtitle && (
        <span className="text-blue-500 font-bold tracking-widest uppercase text-sm mb-3 block">
          {subtitle}
        </span>
      )}
      <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
        {title}
      </h2>
      {description && (
        <p className={`text-slate-400 text-lg md:text-xl max-w-3xl ${centered ? 'mx-auto' : ''}`}>
          {description}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;